import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
import ApiRequest from "../../helper/ApiRequest";
import DataTable from '../../component/DataTable';
import AdminHeader from "../../component/AdminHeader";
import { ApiEndpoints } from "../../helper/ApiEndpoints";
const ListPriceEndpoint = ApiEndpoints?.price?.priceList;

const PriceEditPath = "edit-price"
const tableHeader = ["Name"];
const tbody = ["name"];

export default function AdminPrice() {
  const [data, setData] = useState([]);

  const dataFetch = async () => {
    try {
      const response = await ApiRequest("GET", ListPriceEndpoint);
      const result = response.plans;
      setData(result);
    } catch (error) {
      console.error(error);
    }
  };
  useEffect(() => {
    dataFetch();
  }, []);

  const pagename = {
    name: 'Pricing',
    user: 'Admin',
    innerpage: 'Pricing Management / Pricing'
  }

  return (
    <>
      <AdminHeader pagename={pagename} />
      <div className="add-btn-section">
        {data && data.length > 0 ? "" : (
          <Link className=" admin-add-btn " to="/add-price">
            Add Pricing
          </Link>
        )}
        <DataTable
          data={data && data.length > 0 ? [{ name: "Pricing Plan", _id: "pricing" },] : []}
          tableHeader={tableHeader}
          tbody={tbody}
          editPath={PriceEditPath}
        />
      </div>
    </>
  );
}
